export default "__VITE_ASSET__BeUOTItI__"